import * as notifier from './notifier.js';
import * as loader from './loader.js';
import * as invoices from '../xhr/invoices.js';

/**
 * @param dispatch
 * @param isLoading
 * @param type
 */
function setLoader(dispatch, isLoading, type = 'full') {
    dispatch(loader.setLoader({
        isLoading,
        type
    }));
}

/**
 * @returns {function(*=): Promise<any | never>}
 */
export function getInvoice(invoiceNum) {
    return (dispatch) => {
        setLoader(dispatch, true);

        return invoices
            .get(invoiceNum)
            .then((data) => {
                setLoader(dispatch, false);
                return data;
            })
            .catch((error) => {
                setLoader(dispatch, false);
                dispatch(notifier.displayError(error));
            });
    };
}